import { Logger } from 'loglevel';

// Function pour logger les erreurs
export const logError = (
  logger: Logger,
  error: Error,
  errorInfo: { componentStack?: string | null },
) => {
  logger.error('ErrorBoundary caught an error:', error, errorInfo);

  // Ici vous pouvez envoyer l'erreur à votre service de monitoring
  const errorReport = {
    message: error.message,
    stack: error.stack,
    componentStack: errorInfo.componentStack,
    timestamp: new Date().toISOString(),
    userAgent: navigator.userAgent,
    url: window.location.href,
  };

  // Exemple d'envoi vers un service externe
  // fetch('/api/log-error', {
  //   method: 'POST',
  //   headers: { 'Content-Type': 'application/json' },
  //   body: JSON.stringify(errorReport)
  // }).catch(console.error);
  logger.error('Error Report:', errorReport);
};
